import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { sanitize as sanitizeHtml } from 'isomorphic-dompurify';
import { Fonts, Spacings, breakpoints } from '@styles/index';

export const Container = styled.section`
  grid-column: span 10;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    color: var(--color-text-primary);
  }
  h1 {
    font-size: ${Fonts.H2};
    line-height: ${Fonts.PARA_LINE_HEIGHT};
    margin: 0 0 ${Spacings.SPACING_4B};
  }
  h2,
  h3,
  strong {
    font-size: ${Fonts.H5};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_2B};
  }
  h3 {
    font-size: ${Fonts.H6};
    margin: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_1B};
  }
  p {
    font-size: ${Fonts.SMALL};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: var(--color-text-primary);
    margin: 0 0 ${Spacings.SPACING_4B};
  }
  ul,
  ol {
    padding: 0 0 0 ${Spacings.SPACING_3B};
    margin: 16px 0 16px 16px;
    color: var(--color-text-primary);
    li {
      margin-bottom: 4px;
      line-height: 150%;
      font-size: 14px;
      color: var(--color-text-primary);
    }
  }
  table {
    text-align: left;
    border-radius: ${Spacings.SPACING_2B};
    border-collapse: collapse;
    margin: 32px 0;
    @media only screen and (max-width: ${breakpoints.mobile}) {
      margin: 24px 0;
    }
    ul {
      padding: 0 0 0 ${Spacings.SPACING_3B};
      margin: 16px 0 16px 16px;
      color: var(--color-text-primary);
      li {
        margin-bottom: 4px;
      }
    }
    tr {
      th,
      td {
        border: ${Spacings.SPACING_1} solid var(--color-divider);
        padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
        font-size: ${Fonts.SMALL};
        line-height: ${Fonts.HEADER_LINE_HEIGHT};
        font-weight: 600;
      }
      td {
        font-weight: 400;
      }
      th {
        white-space: nowrap;
      }
      ul {
        margin: 0;
        list-style: none;
        li {
          &::before {
            content: '•';
            color: var(--color-text-primary);
            display: inline-block;
            width: 1em;
            margin-left: -1em;
            line-height: 120%;
          }
          margin-bottom: 0;
        }
      }
    }
  }
  section {
    padding-top: ${Spacings.SPACING_8B};
    h2 {
      margin-top: 0;
    }
  }

  #module4 {
    margin-bottom: 32px;
  }
`;

function CMSHTMLContent({ content }) {
  return (
    <Container
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(content, { allowedAttributes: false })
      }}
    />
  );
}

CMSHTMLContent.propTypes = {
  content: PropTypes.string.isRequired
};

export default CMSHTMLContent;
